import Box from "@material-ui/core/Box";
import { makeStyles } from "@material-ui/core/styles";
import Typography from "@material-ui/core/Typography";
import React from "react";
import {
  FormattedMessage,
  WrappedComponentProps,
  injectIntl,
} from "react-intl";
import SignUpEndImg from "../../Assets/signup_end_contract.png";
import { SAPHEER_COLOR } from "../../../utils/constant";
import { DialogTitle } from "@material-ui/core";
import { MyDialog } from "../../Ui/MyDialog";
import { CustomButton } from "../../Ui/CustomButton";
import { CreditCard, Download } from "lucide-react";

interface ContractDialogSuccessPropsInterface {
  open: boolean;
  handleClose(): void;
  handleDownloadContract(): void;
}

const styles = makeStyles((theme) => ({
  contract: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    textAlign: "center",
    width: 450,
    margin: "auto",
    "@media (max-width: 532px)": {
      width: "100%",
      "& button": {
        margin: 0,
      },
    },
  },
  button: {
    display: "inline-grid",
    justifyContent: "center",
    alignItems: "center",
    margin: theme.spacing(2, 0),
    "& button + button": {
      marginTop: theme.spacing(2),
    },
  },
  text: {
    fontSize: ".85rem",
    lineHeight: 1.5,
    whiteSpace: "normal",
    overflowWrap: "break-word",
    color: "#4e5d78",
  },
}));

const ContractDialogSuccess = (
  props: ContractDialogSuccessPropsInterface & WrappedComponentProps,
) => {
  const classes = styles();
  const { open, handleClose, intl, handleDownloadContract } = props;

  return (
    <MyDialog
      open={open}
      onClose={handleClose}
      fullWidth
      maxWidth="sm"
      dialogTitle={
        <DialogTitle>
          {intl.formatMessage({ id: "contract.label.registrationCompleted" })}
        </DialogTitle>
      }
    >
      <Box className={classes.contract}>
        <Box paddingTop={4} paddingBottom={4}>
          <img src={SignUpEndImg} width="75px" alt="Congratulation" />
        </Box>

        <Typography
          variant="h4"
          style={{ fontWeight: 500, color: SAPHEER_COLOR }}
        >
          <FormattedMessage id="contract.label.text.congratulation" />
        </Typography>
        <Box margin={2}>
          <Typography className={classes.text}>
            <FormattedMessage id="contract.text.emailContractSent" />
          </Typography>
          <Typography className={classes.text}>
            <FormattedMessage id="or" />
          </Typography>
        </Box>
        <Box className={classes.button}>
          <CustomButton
            type="button"
            variant="primary"
            onClick={handleDownloadContract}
            label="contract.downloadContract"
            fullWidthMobile
            startIcon={<Download className="w-4 h-4 mr-2" />}
          />
          <CustomButton
            type="button"
            variant="outline4"
            onClick={handleClose}
            label="contract.label.accessTheDashboard"
            fullWidthMobile
            startIcon={<CreditCard className="w-4 h-4 mr-2" />}
          />
        </Box>
      </Box>
    </MyDialog>
  );
};

export default injectIntl(ContractDialogSuccess);
